// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rnXJ","type":"styles_type__sw_8r","choices":"styles_choices__2FbKf"};